module.exports = __webpack_public_path__ + "static/media/blurred-image-red.2415c91c.jpg";